function extractBase64(pemPublicKey) {
    return pemPublicKey
        .replace("-----BEGIN PUBLIC KEY-----\n", '')
        .replace("\n-----END PUBLIC KEY-----", '')
        .replace(/\n/g, '');
}

async function computeSha1(input) {
    const encoder = new TextEncoder();
    const data = encoder.encode(input);
    const hash = await window.crypto.subtle.digest('SHA-1', data);
    const hashArray = Array.from(new Uint8Array(hash)); // convert buffer to byte array
    const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join(''); // convert bytes to hex string
    return hashHex;
}

async function computeThumbprint(pemPublicKey) {
    const base64Key = extractBase64(pemPublicKey);
    return await computeSha1(base64Key);
}

async function encryptPasswordWithKey(key, pass) {
    const password = pass;
    let base64PublicKey = key;

    if(password && base64PublicKey){
        // Generate a salt of 16 bytes
        const salt = window.crypto.getRandomValues(new Uint8Array(16));

        // Encode the salt in base64
        const base64Salt = btoa(String.fromCharCode.apply(null, salt));

        // Combine the salt and the password
        const saltedPassword = password + base64Salt;

        // Convert the public key to a buffer
        const publicKeyBuffer = Uint8Array.from(atob(base64PublicKey), c => c.charCodeAt(0)).buffer;

        // Import the public key
        const importedKey = await window.crypto.subtle.importKey(
            'spki',
            publicKeyBuffer,
            {
                name: 'RSA-OAEP',
                hash: 'SHA-256'
            },
            false,
            ['encrypt']
        );

        // Convert the saltedPassword to an ArrayBuffer
        const encoder = new TextEncoder();
        const passwordBuffer = encoder.encode(saltedPassword);

        // Encrypt the password
        const encryptedPassword = await window.crypto.subtle.encrypt(
            {
                name: 'RSA-OAEP'
            },
            importedKey,
            passwordBuffer
        );

        // Convert the encrypted password to base64
        const encryptedPasswordBase64 = btoa(String.fromCharCode(...new Uint8Array(encryptedPassword)));

        return {
            "saltsize" : 16,
            "saltbase64" : base64Salt,
            "cipherkeysize" : 2048,
            "thumbprint" : await computeThumbprint(key),
            "password" : encryptedPasswordBase64,
            "encryptionpadding" : "OAEPSHA256"
        };
    }
}

export default encryptPasswordWithKey;